import { Sequence } from "../interfaces/models/TaskSequence";

// Arrange list of sequences into alphabetical order by their name
export const sortSequencesByName = (sequences: Sequence[]) => {
     // use slice() here to make a copy of the array first - as its frozen and cannot be modified otherwise
    return sequences.slice().sort((a,b) => a.name.localeCompare(b.name, undefined, {numeric: true}))
}
